package com.example.borshi.web.nutritionist.models

import kotlinx.serialization.Serializable

@Serializable
data class DashboardStats(
    val totalPatients: Int = 0,
    val activePatients: Int = 0,
    val averageAdherence: Int = 0,
    val plansCreated: Int = 0,
    val activeAlerts: Int = 0,
    val todayAppointments: Int = 0,
    val pendingReviews: Int = 0
)

